import { createContext, useContext, useState, ReactNode } from 'react';

interface MenuContextType {
  menuWidth: number;
  setIsMenuOpen: (isOpen: boolean) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider = ({ children }: { children: ReactNode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  const defaultMenuWidth = 250;
  const menuWidth = isMenuOpen ? defaultMenuWidth : 0;

  return (
    <MenuContext.Provider value={{ setIsMenuOpen, menuWidth }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = (): MenuContextType => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
};
